import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFunctionalImapctFormData } from '../../commons/types';
import { IGetClientStatementData } from '../api/types/leadership';

interface IFunctionalImpactSLModalProps {
  isOpen: boolean;
  modalType: 'add' | 'edit';
  initialValues: IFunctionalImapctFormData;
  filteredSubFunctionList: [];
}

const initialState: IFunctionalImpactSLModalProps = {
  isOpen: false,
  modalType: 'add',
  initialValues: {
    id: '',
    name: '',
    impact_area: '',
    leadership_acumen: '',
    description: '',
  },
  filteredSubFunctionList: [],
};

const functionalImpactSLModalSlice = createSlice({
  name: 'functionalImpactSLModal',
  initialState,
  reducers: {
    closeFunctionalImpactSLModal: (state) => {
      state.isOpen = false;
      state.initialValues = initialState.initialValues;
    },
    openAddFunctionalImpactSLModal: () => ({
      ...initialState,
      isOpen: true,
    }),
    openEditFunctionalImpactSLModal: (
      state,
      action: PayloadAction<IGetClientStatementData>
    ) => {
      state.isOpen = true;
      state.modalType = 'edit';
      state.initialValues = {
        id: action.payload.id || '',
        name: action.payload.name || '',
        impact_area:
          action.payload.impactModuleCode || action.payload.module_number || '',
        leadership_acumen:
          action.payload.expertiseCategoryCode ||
          (action.payload.leadership_acumen
            ? action.payload.leadership_acumen
            : '') ||
          '',
        description: action.payload.description || '',
      };
    },
  },
});

export const functionalImpactSLModalActions =
  functionalImpactSLModalSlice.actions;
export const functionalImpactSLModalReducer =
  functionalImpactSLModalSlice.reducer;
